import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import LoadingScreen from './LoadingScreen';

const AdminOrganizationApproval = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPendingOrganizations();
  }, []);

  const fetchPendingOrganizations = async () => {
    try {
      const orgsQuery = query(
        collection(db, 'organizations'),
        where('approved', '==', false)
      );
      const querySnapshot = await getDocs(orgsQuery);
      const orgs = [];
      querySnapshot.forEach((doc) => {
        orgs.push({ id: doc.id, ...doc.data() });
      });
      setOrganizations(orgs);
    } catch (err) {
      setError('Failed to fetch organizations');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (orgId) => {
    try {
      const orgRef = doc(db, 'organizations', orgId);
      await updateDoc(orgRef, {
        approved: true,
        approvedAt: new Date().toISOString()
      });
      
      // Refresh the list
      await fetchPendingOrganizations();
    } catch (err) {
      setError('Failed to approve organization');
    }
  };

  if (loading) {
    return <LoadingScreen message="Loading organizations..." variant="fullscreen" />;
  }

  return (
    <div className="container">
      <div className="admin-container">
        <h1 className="text-h1">Organization Approvals</h1>
        {error && <div className="error-message text-body color-danger">{error}</div>}
        
        {organizations.length === 0 ? (
          <p className="text-body color-secondary">No pending organizations for approval</p>
        ) : (
          <div className="organizations-list">
            {organizations.map((org) => (
              <div key={org.id} className="organization-card card">
                <h3 className="text-h3">{org.name}</h3>
                <p className="text-body color-secondary">Email: {org.email}</p>
                <p className="text-body color-secondary">Phone: {org.phoneNumber}</p>
                <p className="text-body color-secondary">Organization Code: {org.organizationCode}</p>
                <p className="text-body color-secondary">Created: {new Date(org.createdAt).toLocaleString()}</p>
                <button
                  onClick={() => handleApprove(org.id)}
                  className="approve-button button-primary"
                >
                  Approve Organization
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminOrganizationApproval; 